import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/context/I18nContext";

// Order replacement status ("annule et remplace")
export const ReplaceBadge = ({ quote }) => {
  const { t } = useI18n();
  const n = quote.quote_number;
  if (quote.cancelled) return <div><Badge variant="outline" className="mt-1 text-[10px] border-destructive text-destructive" data-testid={`cancelled-${n}`}>{t("Annulée et remplacée par")} {quote.cancelled_by_number}</Badge></div>;
  return (<>
    {quote.suspended_by && <div><Badge variant="outline" className="mt-1 text-[10px] border-amber-600 text-amber-700" data-testid={`suspended-${n}`}>{t("Suspendue : modification en cours")} {quote.suspended_by_number}</Badge></div>}
    {quote.replaces_number && <div><Badge variant="outline" className="mt-1 text-[10px] border-primary text-primary" data-testid={`replaces-${n}`}>{t("Annule et remplace")} {quote.replaces_number}</Badge></div>}
  </>);
};
